export default __webpack_public_path__ + "51d22c335c9eda3a41d9913185988f58.png";